import { NextSeo } from "next-seo";
import { EmployeesFeaturesSection } from "@/components/landing/employees-features-section";
import { EmployersFeaturesSection } from "@/components/landing/employers-features-section";
import { FAQSection } from "@/components/landing/faq-section";
import { FooterCTA } from "@/components/landing/footer-cta";
import { FooterSection } from "@/components/landing/footer-section";
import { HeroSection } from "@/components/landing/hero-section";
import { LandingHeader } from "@/components/landing/landing-header";
// import { PricingSection } from '@/components/landing/pricing-section';
import { RoadmapSection } from "@/components/landing/roadmap-section";
import { StatsSection } from "@/components/landing/stats-section";
import { TestimonialsSection } from "@/components/landing/testimonial-section";
import { getLayout } from "@/components/layouts/landing";

export default function LandingPage() {
  return (
    <>
      <NextSeo
        canonical="https://www.vacwork.app/"
        description="VacWork connects employers and employees for flexible, piecemeal jobs and services. Discover, hire, and work with ease."
        title="VacWork: The marketplace for piecemeal jobs & services"
      />
      <div className="flex min-h-dvh flex-col">
        <LandingHeader />
        <main className="flex-1" id="main-content">
          <HeroSection />
          <EmployersFeaturesSection />
          <EmployeesFeaturesSection />
          <RoadmapSection />
          <StatsSection />
          <FAQSection />
          <TestimonialsSection />
          {/* <PricingSection /> */}
          <FooterCTA />
          <FooterSection />
        </main>
      </div>
    </>
  );
}

LandingPage.getLayout = getLayout;
